rs.module("core/ui/controls/newpassword",

    [],

    function () {

        // Initialize password strength 
        function initialize(jsSelectors) {

            var password = $.js(jsSelectors.password);
            var passwordErrorMessage = $.js(jsSelectors.passwordErrorMessage);
            var minimumLength = password.data("min-length");
            var requireMixedCase = password.data("require-mixed-case");
            var requireNumber = password.data("require-number");
            var requireSymbol = password.data("require-symbol");
            var allowedSymbols = password.data("allowed-symbols");
            var usernameFieldName = password.data("username-field");
            var displayNameFieldName = password.data("displayname-field");

            password.pwstrength({
                common: {
                    onKeyUp: function (evt, data) {
                        $('.password-strength__progress-bar').toggleClass('_visible', $(evt.target).val().length > 0);
                    },
                    invalidCharsRegExp: new RegExp(/[\s,'""<>]/),
                    minChar: minimumLength,
                    maxChar: 20,
                    username: getUsername(),
                    displayName: getDisplayName()
                },
                rules: {
                    extra: {
                        alphaNumeric: function (options, word, score) {
                            return word.match(/^.*(?=.*\d)(?=.*[a-zA-Z]).*$/) ? 0 : score;
                        },
                        mixedCase: function (options, word, score) {
                            return word.match(/^.*(?=.*[a-z])(?=.*[A-Z]).*$/) ? 0 : score;
                        },
                        symbols: function (options, word, score) {
                            return word.match(new RegExp(`^.*(?=.*[${allowedSymbols}]).*$`)) ? 0 : score;
                        },
                        usernameSubstring: function (options, word, score) {
                            var username = getUsername();
                            return containsUsernameSubstring(word, username, 3) ? score : 0;
                        },
                        displayNameSubstring: function (options, word, score) {
                            var displayName = getDisplayName();
                            return containsDisplayNameSubstring(word, displayName, 3) ? score : 0;
                        },
                    },
                    scores: {
                        alphaNumeric: -10,
                        mixedCase: -10,
                        symbols: -10,
                        usernameSubstring: -100,
                        displayNameSubstring: -100,

                        wordNotEmail: -100,
                        wordMinLength: -50,
                        wordMaxLength: -50,
                        wordInvalidChar: -10,
                        wordSimilarToUsername: -100,
                        wordSequences: -50,
                        wordTwoCharacterClasses: 2,
                        wordRepetitions: -25,
                        wordLowercase: 1,
                        wordUppercase: 3,
                        wordOneNumber: 3,
                        wordThreeNumbers: 5,
                        wordOneSpecialChar: 3,
                        wordTwoSpecialChar: 5,
                        wordUpperLowerCombo: 2,
                        wordLetterNumberCombo: 2,
                        wordLetterNumberCharCombo: 2
                    },
                    activated: {
                        alphaNumeric: requireNumber,
                        mixedCase: requireMixedCase,
                        symbols: requireSymbol,
                        usernameSubstring: true,
                        displayNameSubstring: true,

                        wordNotEmail: false,
                        wordMinLength: true,
                        wordMaxLength: false,
                        wordInvalidChar: true,
                        wordSimilarToUsername: false,
                        wordSequences: false,
                        wordTwoCharacterClasses: false,
                        wordRepetitions: false,
                        wordLowercase: true,
                        wordUppercase: true,
                        wordOneNumber: true,
                        wordThreeNumbers: true,
                        wordOneSpecialChar: true,
                        wordTwoSpecialChar: true,
                        wordUpperLowerCombo: true,
                        wordLetterNumberCombo: true,
                        wordLetterNumberCharCombo: true
                    }
                },
                ui: {
                    progressExtraCssClasses: 'password-strength__progress-bar',
                    useVerdictCssClass: true,
                    showErrors: true
                },
                i18n: {
                    t: function (key) {
                        var messages = {
                            alphaNumeric: 'Your password must be alphanumeric',
                            mixedCase: 'Your password must include both upper and lower case characters',
                            symbols: `Your password must include at least one symbol: ${allowedSymbols.replaceAll(",", " ")}`,
                            usernameSubstring: 'Your password cannot contain three or more consecutive characters from your username',
                            displayNameSubstring: 'Your password cannot contain three or more consecutive characters from your display name',

                            wordMinLength: `Your password must be at least ${minimumLength} characters long`,
                            wordMaxLength: 'Your password is too long',
                            wordInvalidChar: 'Your password contains an invalid character',
                            wordNotEmail: 'Do not use your email as your password',
                            wordSimilarToUsername: 'Your password cannot contain your username',
                            wordTwoCharacterClasses: 'Use different character classes',
                            wordRepetitions: 'Too many repetitions',
                            wordSequences: 'Your password contains sequences',
                            errorList: 'Errors:',
                            veryWeak: 'Very Weak',
                            weak: 'Weak',
                            normal: 'Normal',
                            medium: 'Medium',
                            strong: 'Strong',
                            veryStrong: 'Very Strong',
                        }

                        return messages[key];
                    }
                }
            });
            function getUsername() {
                if (!usernameFieldName) return null;

                var $username = $(`[name="${usernameFieldName}"]`);
                return $username.length ? $username.val() : null;
            }

            function getDisplayName() {
                if (!displayNameFieldName) return null;

                var $displayName = $(`[name="${displayNameFieldName}"]`);
                return $displayName.length ? $displayName.val() : null;
            }

            function containsUsernameSubstring(password, username, minLength) {
                if (!password || !username || username.length < minLength) {
                    return false;
                }

                password = password.toLowerCase();
                username = username.toLowerCase();

                for (var i = 0; i <= username.length - minLength; i++) {
                    var fragment = username.substr(i, minLength);
                    if (password.indexOf(fragment) !== -1) {
                        return true;
                    }
                }

                return false;
            }

            function containsDisplayNameSubstring(password, displayName, minLength) {
                if (!password || !displayName || displayName.length < minLength) {
                    return false;
                }

                password = password.toLowerCase();
                displayName = displayName.trim().toLowerCase();

                for (var i = 0; i <= displayName.length - minLength; i++) {
                    var fragment = displayName.substr(i, minLength);
                    if (password.indexOf(fragment) !== -1) {
                        return true;
                    }
                }

                return false;
            }
        }

        // Exported public API
        var exports = {
            initialize
        };

        return exports;
    }
);